import React from 'react';
import { i18n, openCallMeModal, PropertyTypeEnum } from 'src/common';
import { Flex, PropertyTypeButton, HouseIcon, ApartmentIcon, StepHeader, ContainerComponent, Card } from 'src/components';
import { RequestAgentCardV2 } from 'src/components/cards/requestAgentCardV2.card';
import { NavigationService } from 'src/common/utils/navigation.util';
import { AppRoutes } from './_router/app.routes';
import { Helmet } from 'react-helmet-async';
export const PropertyTypePage: React.FC = () => {
  const handleContinue = (type: PropertyTypeEnum.HOUSE | PropertyTypeEnum.APARTMENT) => {
    if (type === PropertyTypeEnum.APARTMENT) {
      NavigationService.navigate(AppRoutes.WEBSHOP.PROPERTY_INFO);
    } else {
      NavigationService.navigate(AppRoutes.FUNNEL.RISKS);
    }
  };

  return (
    <ContainerComponent>
      <Helmet>
        <title>Osiguraj nekretninu | Osiguranje imovine - kompare.hr</title>
      </Helmet>
      <StepHeader/>
      <Card style={{ padding: 24, marginBottom: 16, }}>
        <Flex gap={12}>
          <PropertyTypeButton
            icon={<ApartmentIcon size={32} />}
            text={i18n.t('funnel.step1.propertyTypes.apartment')}
            onClick={() => handleContinue(PropertyTypeEnum.APARTMENT)}
          />
          <PropertyTypeButton
            icon={<HouseIcon size={32} />}
            text={i18n.t('funnel.step1.propertyTypes.house')}
            onClick={() => handleContinue(PropertyTypeEnum.HOUSE)}
          />
        </Flex>
      </Card>
      <RequestAgentCardV2
        onButtonClick={openCallMeModal}
      />
    </ContainerComponent>
  );
};

export default PropertyTypePage;
